import PropTypes from 'prop-types';
import React from 'react';
import { Common } from 'ws-scripts/modules/common';

import {
	DEALERSHIP_NAME_PRICE,
	DETAILS,
	PLEASE_CALL
} from '../constants/labels';
import { replacePlaceholders } from '../utils/utility';
import './PricingSummaryFooter.scss';

export default class PricingSummaryFooter extends React.Component {
	render() {
		const { summary } = this.props;
		const displayPrice = summary.find(price => price.isFinalPrice);
		if (!displayPrice) {
			return null;
		}
		return (
			<Common
				render={({ labels }) => {
					const dealershipNamePriceText = replacePlaceholders(
						labels.get(DEALERSHIP_NAME_PRICE),
						{
							'<%=dealershipName%>': displayPrice.dealershipName
						}
					);

					let formattedValue = displayPrice.formatted;

					if (formattedValue === PLEASE_CALL) {
						formattedValue = labels.get(PLEASE_CALL);
					}
					return (
						// using aria-hidden based on conversation with Rachael Arnold
						// and Jon Ferry. The data in the footer section is redundant
						// and comes after the detailed pricing data in the DOM

						<div
							onClick={this.props.viewPriceDetail}
							role="button"
							aria-hidden
						>
							<ul className="pricing-summary list-unstyled line-height-condensed mb-2">
								<li className="text-muted">
									<span className="d-block text-truncate">
										{dealershipNamePriceText}
									</span>
								</li>
								<li>
									<strong className="pr-3">
										{formattedValue}
									</strong>
									<span className="text-link">
										{labels.get(DETAILS)}
									</span>
								</li>
							</ul>
						</div>
					);
				}}
			/>
		);
	}
}

PricingSummaryFooter.propTypes = {
	summary: PropTypes.arrayOf(
		PropTypes.shape({
			_type: PropTypes.string.isRequired,
			formatted: PropTypes.string.isRequired,
			label: PropTypes.string.isRequired,
			value: PropTypes.number.isRequired
		})
	).isRequired,
	viewPriceDetail: PropTypes.func.isRequired
};



// WEBPACK FOOTER //
// ./src/components/PricingSummaryFooter.jsx